import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { CreateInviteInput, InviteRow, ListInvitesParams } from "../invites.types";
import { createInvite, deleteInvites, grantCreateWorkspacePermission } from "./invites-api";
import { inviteQueries } from "./invites-keys";

export function useCreateInviteMutation() {
  const queryClient = useQueryClient();

  return useMutation<InviteRow, Error, CreateInviteInput>({
    mutationFn: createInvite,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: inviteQueries.all(),
      });
    },
  });
}

export function useDeleteInvitesMutation() {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string[]>({
    mutationFn: deleteInvites,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: inviteQueries.all(),
      });
    },
  });
}

export function useInvitesQuery(params?: ListInvitesParams) {
  return useQuery(inviteQueries.list(params));
}

export function useGrantCreateWorkspacePermissionMutation() {
  return useMutation<string, Error, string>({
    mutationFn: grantCreateWorkspacePermission,
  });
}
